<template>
  <header class="d-flex flex-row gap-2 align-center justify-space-between">
    <div class="d-flex align-center">
      <opendock-graphic class="logo" role="img" aria-label="OpenDock Logo" />
    </div>
    <warehouse-select-dialog />
    <v-btn
      variant="text"
      size="small"
      class="px-1 d-flex align-center gap-1"
      append-icon="mdi-logout"
      @click="handleLogout">
      <span class="typography-button-md d-none d-md-flex">{{ t('global.basicTerms.logout') }}</span>
    </v-btn>
  </header>
</template>

<script lang="ts" setup>
import OpendockGraphic from '@/assets/opendock_graphic.svg';
import WarehouseSelectDialog from '@/components/WarehouseSelectDialog.vue';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/store/useAuthStore.ts';
import { useRouter } from 'vue-router';
import { useWarehouseStore } from '@/store/useWarehouseStore';

const { t } = useI18n();

const { logout } = useAuthStore();
const { clearSelectedWarehouse } = useWarehouseStore();
const router = useRouter();

const handleLogout = async () => {
  logout();
  clearSelectedWarehouse();
  await router.replace({ name: 'login' });
};
</script>

<style lang="scss" scoped>
header {
  block-size: 60px;
  padding: $spacing-2 $spacing-3;
  border-bottom: 1px solid $color-line-divider;

  .logo {
    fill: $color-primary-60;
    height: auto;
    width: $spacing-5;
  }
}
</style>
